import {useEffect} from "react";

const Accident=()=>{
    useEffect(()=>{

        window.location.href='http://195.181.42.3:9084/'
    })
    return <>
    </>
}
export default Accident;